export default class {

    /**
     * slicer
     * @param {String} text 対象となる文字列
     * @param {Number} length カットすべき文字数
     * @return {String} 整形済みの文字列
     */
    slicer(text, length = 30, addLetter = '…'){
    	if (text.length > length) {
    		return text.slice(0, length) + addLetter;
    	} else {
    		return text;
    	};
    }

    /**
     * wrapping
     * @param {String} targetClass ターゲット要素のクラス名
     * @param {String} letterClass ラップしたspanに当てるクラス名
     */
    wrapping(target, letterClass = ''){
        let nodes = target.childNodes;
        let convert = [];

        for (let node of nodes) {
            if (node.nodeType == 3) { // テキストの場合
                let text = node.textContent;
                text.split('').forEach((v) => {
                    if (v === ' ') {
                        convert.push('<span class="' + letterClass + '" style="width: .24em;">' + v + '</span>');
                    } else if (v === '　') {
                        convert.push('<span class="' + letterClass + '" style="width: 1em;">' + v + '</span>');
                    } else {
                        convert.push('<span class="' + letterClass + '">' + v + '</span>');
                    };
                });
            } else { // テキスト以外
                convert.push(node.outerHTML);
            };
        };

        target.innerHTML = convert.join('');
    }

}